export default __webpack_public_path__ + "static/bil-b8769a4272be1dba4c2e45e35438897a.jpg";